import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { BoxBone } from '../../atoms/BoxBone/BoxBone';

interface SimplePanelBoneProps {
    /** Largeur */
    width?: string;
    /** Hauteur */
    height?: string;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const SimplePanelBone: React.FunctionComponent<SimplePanelBoneProps> = function ({
    width = '90%',
    height = '100%',
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                ...sx,
            }}
        >
            <BoxBone
                sx={{
                    width,
                    height,
                }}
            />
        </Box>
    );
};
